import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
  Box,
  Grid,
  Menu,
  MenuItem,
  Divider,
  Select,
  InputBase,
  Icon,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material"
import SearchField from "../../../components/Form/Input/SearchField"
import {
  getLivisLanguage,
  getLivistheme,
  getLivisUserInfo,
  resetLivisUserInfo,
  getLivisBrandColor,
  getLivisBrandTheme
} from "../../../helpers/storage"
import { brandColors, changeTheme, changeBrandColor } from "../../../helpers/globalTheme"
import CloseIcon from "@mui/icons-material/Close"
import LightModeIcon from "@mui/icons-material/LightMode"
import DarkModeIcon from "@mui/icons-material/DarkMode"
import { setIsLoading } from "../../../store/actions"
import { useDispatch } from "react-redux"
import { livisAlert } from "../../../helpers/alert"
import { ArrowDropDownCircleOutlined } from "@material-ui/icons"
import { languages } from "../../../localisation/HeaderFormJSON"
import LivisModal from "../../Modals/LivisModal"
import {
  AlertRegularIcon,
  DashboardActiveIcon,
  DashboardIcon,
  HamburgerIcon,
  InspectorActiveIcon,
  InspectorIcon,
  LayoutActiveIcon,
  LayoutIcon,
  PowerRegularIcon,
  RecipeActiveIcon,
  RecipeIcon,
  ReportsActiveIcon,
  ReportsIcon,
  SettingsBoldIcon,
  SettingsRegularIcon,
  StationActiveIcon,
  StationIcon,
} from "../../Icons/LivisIcons"
import { LockKeyhole, ShieldAlert, LogOut, PaintBucket, Sun, Moon, User } from "lucide-react"
import {
  doesUserHasAccess,
  formatString,
  setupLivisThemeSync,
} from "../../../helpers/utils"
import { getPlanExpiredStatus } from "../../../services/userManagement"
import LivisNotificationMenu from "../../../modules/notifications/components/notification-header-dropdown/LivisNotificationMenu"
import { useNotification } from "../../../contexts/NotificationContext"
import TrialAlertBanner from "../../../modules/notifications/components/alert/TrialAlertBanner"
import { usePlanExpiry } from "../../../hooks/queries/useUser"

const getIndustryName = () => {
  try {
    const hostname = window.location.hostname
    if (hostname.includes("automotive")) return "Automotive"
    if (hostname.includes("aerospace")) return "Aerospace"
    if (hostname.includes("electronics")) return "Electronics"
    if (hostname.includes("semi")) return "Semiconductor"
  } catch (error) {
    console.log("Error loading ")
  }
  return ""
}

const LandingHeader = (props: any = null) => {
  const industryName = getIndustryName()
  const {
    livis_logo,
    page_title,
    search_icon,
    setting_icon,
    alert_icon,
    profile_icon,
    setting_icon_bold,
    alert_icon_bold,
    livis_hamburger,
  } = props.landing_page_props

  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // 2. Get unreadCount from Context
  const { unreadCount } = useNotification()

  const route = window.location.href.split("app/")[1].split("/")[0]

  const station_icon = process.env.PUBLIC_URL + "/image/menu/station.svg"
  const station_active_icon =
    process.env.PUBLIC_URL + "/image/menu/station_active.svg"
  const reports_icon = process.env.PUBLIC_URL + "/image/menu/reports.svg"
  const reports_active_icon =
    process.env.PUBLIC_URL + "/image/menu/reports_active.svg"
  const recipe_icon = process.env.PUBLIC_URL + "/image/menu/recipe.svg"
  const recipe_active_icon =
    process.env.PUBLIC_URL + "/image/menu/recipe_active.svg"
  const layout_icon = process.env.PUBLIC_URL + "/image/menu/layout.svg"
  const layout_active_icon =
    process.env.PUBLIC_URL + "/image/menu/layout_active.svg"
  const inspectron_icon = process.env.PUBLIC_URL + "/image/menu/inspector.svg"
  const inspectron_active_icon =
    process.env.PUBLIC_URL + "/image/menu/inspector_active.svg"
  const dashboard_icon = process.env.PUBLIC_URL + "/image/menu/dashboard.svg"
  const dashboard_active_icon =
    process.env.PUBLIC_URL + "/image/menu/dashboard_active.svg"
  const globe_icon = process.env.PUBLIC_URL + "/image/icons/globe.svg"

  const power_icon = process.env.PUBLIC_URL + "/image/menu/power.svg"
  const power_active_icon =
    process.env.PUBLIC_URL + "/image/menu/power_active.svg"
  const livis_logo_dark =
    process.env.PUBLIC_URL + "/image/icons/lincode_logo_dark.svg"
  const [livisLogo, setLivisLogo] = useState(livis_logo)
  const [theme, setTheme] = useState<string>(getLivistheme())

  const [profileEl, setProfileEl] = useState<null | HTMLElement>(null)
  const [notificationEl, setNotificationEl] = useState<null | HTMLElement>(null)
  const [hamburgerEl, setHamburgerEl] = React.useState<null | HTMLElement>(null)

  const [selectedLanguage, setSelectedLanguage] = useState("")
  const [selectedIcon, setSelectedIcon] = useState(globe_icon)
  const [logoutModal, setLogoutModal] = useState(false)
  // const [selectedTheme, setSelectedTheme] = useState("light");
 // const [planExpired, setPlanExpired] = useState(false)

  const openProfileMenu = Boolean(profileEl)
  const openNotificationMenu = Boolean(notificationEl)
  const openHamburger = Boolean(hamburgerEl)
  const userInfoString: any = getLivisUserInfo()
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null

  const [themeEl, setThemeEl] = useState<null | HTMLElement>(null)
  const openThemeMenu = Boolean(themeEl)
  const [currentThemeMode, setCurrentThemeMode] = useState<'light' | 'dark'>('light')
  const [currentBrandColor, setCurrentBrandColor] = useState<string>('#0857DE')

  useEffect(() => {
    const savedTheme = getLivistheme() as 'light' | 'dark'
    const savedColor = getLivisBrandColor()
    const savedBrandTheme = getLivisBrandTheme()

    let themeMode: 'light' | 'dark' = 'light'
    if (savedBrandTheme) {
      themeMode = savedBrandTheme.includes('-dark-') ? 'dark' : 'light'
    } else if (savedTheme) {
      themeMode = savedTheme
    }

    const validColor = brandColors.find(brand => brand.value === savedColor)?.value || '#0857de'

    setCurrentThemeMode(themeMode)
    setCurrentBrandColor(validColor)
  }, [])

  const handleNavigate = (route: any) => {
    if (!route?.length) {
      livisAlert(`${t("Invalid Click")}`, "warning")
    }
    if (
      window.location.href.includes("/app/annotate") ||
      window.location.href.includes("/app/testing/resolve") ||
      window.location.href.includes("/app/synthetic-data/generate/")
    ) {
      window.location.href = route
    }
    const user_info_string: any = getLivisUserInfo()
    const user_info = user_info_string ? JSON.parse(user_info_string) : null
    const isSuperuser = user_info?.is_superuser
    if (isSuperuser) {
      navigate(route)
      return
    }
    const permissions = user_info?.user_permissions
    console.log(
      route,
      route === "/app/client/user/manage",
      permissions?.includes(151),
      permissions?.includes(93),
      permissions?.includes(94)
    )
    if (route === "/app/client/user/manage") {
      if (permissions?.includes(151)) {
        navigate(route)
      } else if (permissions?.includes(93)) {
        navigate("/app/logs")
      } else if (permissions?.includes(94)) {
        navigate("app/tag-management")
      } else {
        navigate("/app/no-access?from=Settings")
      }
    } else {
      navigate(route)
    }
  }

  const handleTabNavigateWorkstation = (e: any, route: any) => {
    if (!route?.length) {
      livisAlert(`${t("Invalid Click")}`, "warning")
      return // Early return for invalid route
    }

    if (e.key === "Enter") {
      // Handle specific redirects using window.location.href
      if (
        window.location.href.includes("/app/annotate") ||
        window.location.href.includes("/app/testing/resolve") ||
        window.location.href.includes("/app/synthetic-data/generate/")
      ) {
        window.location.href = route
        return // Early return after redirect
      }

      const user_info_string: any = getLivisUserInfo()
      const user_info = user_info_string ? JSON.parse(user_info_string) : null
      const isSuperuser = user_info?.is_superuser

      // Superusers can navigate anywhere
      if (isSuperuser) {
        navigate(route)
        return
      }

      const permissions = user_info?.user_permissions || []

      // Handle specific routes with permission checks
      if (route === "/app/client/user/manage") {
        if (permissions.includes(151)) {
          navigate(route)
        } else if (permissions.includes(93)) {
          navigate("/app/logs")
        } else if (permissions.includes(94)) {
          navigate("/app/tag-management")
        } else {
          navigate("/app/no-access?from=Settings")
        }
      }
      // Default case: navigate to any other route
      else {
        navigate(route)
      }

      e.preventDefault() // Prevent default Enter key behavior
    }
  }
  const handleMouseInIcon = (element: any, new_image: string) => {
    console.log(element)
    element.target.setAttribute("src", new_image)
  }

  const handleMouseOutIcon = (element: any, new_image: string) => {
    element.target.setAttribute("src", new_image)
  }

  const handleProfileMenu = (event: any) => {
    setProfileEl(event.currentTarget)
  }

  const handleNotificationMenu = (event: any) => {
    setNotificationEl(event.currentTarget)
  }

  const handleHamburgerMenu = (event: any) => {
    setHamburgerEl(event.currentTarget)
  }

  const handleThemeMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setThemeEl(event.currentTarget)
  }

  const handleThemeMenuClose = () => {
    setThemeEl(null)
  }

  const handleThemeChange = (event: React.MouseEvent<HTMLElement>, newTheme: 'light' | 'dark' | null): void => {
    if (newTheme !== null) {
      setCurrentThemeMode(newTheme)
      changeTheme(newTheme)
    }
  }

  const handleColorChange = (color: string): void => {
    setCurrentBrandColor(color)
    changeBrandColor(color)
  }

  useEffect(() => {
    const currentLanguage = getLivisLanguage()
    console.log(currentLanguage)
    if (currentLanguage) {
      const language = languages.find(
        (item: any) => item?.store === currentLanguage
      )
      if (language && language?.label) {
        const lng_img = process.env.PUBLIC_URL + language.icon
        setSelectedIcon(lng_img)
        // console.log(language)
        setSelectedLanguage(language?.label)
        i18n.changeLanguage(language?.store)
      }
    }

    const currentTheme = getLivistheme()
    // setSelectedTheme(currentTheme);
    document.body.className = `livis-${currentTheme}-theme`
  }, [route, i18n])

  const handleLanguageChange = (e: any) => {
    setSelectedLanguage(e.target.value)
    console.log(e.target.value)
    const language = languages.find(
      (item: any) => item?.label === e.target.value
    )
    if (language && language?.store) {
      console.log(language)
      localStorage.setItem("livis_lang", language?.store)
      // window.location.reload()
      i18n.changeLanguage(language?.store)
    }
    const selectedValue = e.target.value
    const selectedItem = languages.find(
      (item: any) => item.label === selectedValue
    )

    if (selectedItem) {
      const lng_img = process.env.PUBLIC_URL + selectedItem.icon
      setSelectedIcon(lng_img)
    } else {
      setSelectedIcon(globe_icon)
    }
  }

  const handleLogoutModal = () => {
    setLogoutModal(true)
  }

  const handleLogout = () => {
    handleNavigate("/app/logout/")
  }

  const handleViewAllNotifications = () => {
    navigate("/app/all-notifications")
    setNotificationEl(null)
  }

  useEffect(() => {
    if (theme === "dark") {
      setLivisLogo(livis_logo_dark)
    } else {
      setLivisLogo(livis_logo)
    }
  }, [theme])

  useEffect(() => {
    document.body.className = `livis-${theme}-theme`
  }, [theme])

  // const checkPlanExpiry = async () => {
  //   const response = await getPlanExpiredStatus()
  //   if (response?.status == 200) {
  //     if (response?.data?.data) {
  //       setPlanExpired(response?.data?.data?.is_plan_expired)
  //     }
  //   }
  // }

  const { data: planExpiryData } = usePlanExpiry();
  const planExpired = planExpiryData?.isPlanExpired ?? false
  const planNotFound = planExpiryData?.planNotFound ?? false
  // Prefer whatever message the API sends back; only fall back to a generic
  // label when the backend doesn't provide one.
  const planLockMessage =
    planExpiryData?.message || (planNotFound ? t("Plan Not Available") : t("Plan Expired"))

  useEffect(() => {
   // checkPlanExpiry()
    return setupLivisThemeSync(setTheme)
  }, [])

  return (
    <>
      <Box className="livis-landing-header-container">
        <Box className="livis-landing-header-left-container">
          <Box className="livis-landing-header-hamburger-wrap" onClick={handleHamburgerMenu}>
            {/* <img src={livis_hamburger} alt="livis hamburger" onClick={handleHamburgerMenu} /> */}
            <HamburgerIcon  />
          </Box>
          <Box
            className="livis-landing-header-logo-wrap"
            tabIndex={0}
            onClick={() => handleNavigate("/app/inspection/station")}
            onKeyDown={(e) =>
              handleTabNavigateWorkstation(e, "/app/inspection/station")
            }
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <img src={livisLogo} alt="Livis Logo" />
            {industryName && (
              <span
                className="industry-name-text"
                style={{
                  borderLeft: "2px solid #999",
                  paddingLeft: "12px",
                  fontSize: "18px",
                  fontWeight: 600,
                  color: theme === "dark" ? "#fff" : "#333",
                }}
              >
                {t(industryName)}
              </span>
            )}
          </Box>

          <Box
            className={`livis-landing-header-routes-container ${
              planExpired
                ? "livis-landing-header-routes-container-plan-expired"
                : ""
            }`}
          >
            <Box
              className={`livis-landing-header-routes-wrap ${
                route != "reports" &&
                route != "deployment" &&
                route != "builder" &&
                route != "class-library" &&
                route != "color-detection" &&
                route != "inspector" &&
                route != "dashboard" &&
                !route.includes("manage") &&
                route != "tag-management" &&
                route != "logs" &&
                route !== "subscription" &&
                route !== "ongoing-training" &&
                !route.includes("user") &&
                !route.includes("client") &&
                !route.includes("reports") &&
                !route.includes("help-center") &&
                !route.includes("synthetic-data") &&
                !route.includes("supervisor")
                  ? "active"
                  : ""
              }`}
              tabIndex={0}
              onClick={() => handleNavigate("/app/inspection/station")}
              onKeyDown={(e) =>
                handleTabNavigateWorkstation(e, "/app/inspection/station")
              }
            >
              {/* <img src={(route != 'reports' && route != 'deployment' && route != 'builder' && route != 'inspector' && route != 'dashboard' && !route.includes("manage") && route != "tag-management" && route != "logs" && !route.includes("user")) ? station_active_icon : station_icon} alt="" /> */}
              {route != "reports" &&
              route != "deployment" &&
              route != "builder" &&
              route != "inspector" &&
              route != "dashboard" &&
              route != "class-library" &&
              route != "color-detection" &&
              !route.includes("manage") &&
              route != "tag-management" &&
              route != "logs" &&
              route !== "subscription" &&
              route !== "ongoing-training" &&
              !route.includes("user") &&
              !route.includes("client") &&
              !route.includes("reports") &&
              !route.includes("help-center") &&
              !route.includes("synthetic-data") &&
              !route.includes("supervisor") ? (
                <StationActiveIcon />
              ) : (
                <StationIcon />
              )}
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Inspection")}</div>
                <div>{t("Station")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Inspection Station")}
                </Box>
              </Box>
            </Box>

            <Box
              className={`livis-landing-header-routes-wrap ${
                route === "reports" ? "active" : ""
              }`}
              tabIndex={0}
              onClick={() => handleNavigate("/app/reports")}
              onKeyDown={(e) => handleTabNavigateWorkstation(e, "/app/reports")}
            >
              {/* <img src={route === "reports" ? reports_active_icon : reports_icon} alt="" /> */}
              {route === "reports" ? <ReportsActiveIcon /> : <ReportsIcon />}
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Inspection")}</div>
                <div>{t("Reports")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Inspection Reports")}
                </Box>
              </Box>
            </Box>

            <Box
              className={`livis-landing-header-routes-wrap ${
                route === "reports-analytics" ? "active" : ""
              }`}
              tabIndex={0}
              onClick={() => handleNavigate("/app/reports-analytics")}
              onKeyDown={(e) =>
                handleTabNavigateWorkstation(e, "/app/reports-analytics")
              }
            >
              {route === "reports-analytics" ? (
                <DashboardActiveIcon />
              ) : (
                <DashboardIcon />
              )}
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Analytics")}</div>
                <div>{t("Dashboard")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Analytics Dashboard")}
                </Box>
              </Box>
            </Box>

            <Box
              className={`livis-landing-header-routes-wrap ${
                route === "deployment" ? "active" : ""
              }`}
              tabIndex={0}
              onClick={() => handleNavigate("/app/deployment/list")}
              onKeyDown={(e) =>
                handleTabNavigateWorkstation(e, "/app/deployment/list")
              }
            >
              {/* <img src={route === "deployment" ? recipe_active_icon : recipe_icon} alt="" /> */}
              {route === "deployment" ? <RecipeActiveIcon /> : <RecipeIcon />}
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Recipe")}</div>
                <div>{t("Builder")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Recipe Builder")}
                </Box>
              </Box>
            </Box>

            <Box
              className={`livis-landing-header-routes-wrap ${
                route === "builder" ? "active" : ""
              }`}
              tabIndex={0}
              onClick={() => handleNavigate("/app/builder/layouts")}
              onKeyDown={(e) =>
                handleTabNavigateWorkstation(e, "/app/builder/layouts")
              }
            >
              {/* <img src={route === "builder" ? layout_active_icon : layout_icon} alt="" /> */}
              {route === "builder" ? <LayoutActiveIcon /> : <LayoutIcon />}
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Operator")}</div>
                <div>{t("Builder")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Operator Builder")}
                </Box>
              </Box>
            </Box>

            {doesUserHasAccess(175) && (
            <Box className={`livis-landing-header-routes-wrap ${route === "class-library" ? "active" : ""}`} tabIndex={0} onClick={() => handleNavigate("/app/class-library")} onKeyDown={(e) => handleTabNavigateWorkstation(e, "/app/builder/layouts")}>
              {/* <img src={route === "builder" ? layout_active_icon : layout_icon} alt="" /> */}
              {
                route === "class-library" ? (
                  <StationActiveIcon />
                ) : (
                  <StationIcon />
                )
              }
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Class")}</div>
                <div>{t("Library")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Class Library")}
                </Box>
              </Box>
            </Box>
          )}

            {doesUserHasAccess(181) && (
              <Box className={`livis-landing-header-routes-wrap ${route === "color-detection" ? "active" : ""}`} tabIndex={0} onClick={() => handleNavigate("/app/color-detection")} onKeyDown={(e) => handleTabNavigateWorkstation(e, "/app/color-detection")}>
              <PaintBucket 
                style={{ 
                  color: route === "color-detection" ? "#ffffff" : "#667085", 
                  width: "24px", 
                  height: "24px", 
                  marginRight: route === "color-detection" ? "0.35rem" : "0px" 
                }} 
              />
              <Box className="livis-landing-header-routes-text-wrap route-label">
                <div>{t("Color")}</div>
                <div>{t("Detection")}</div>
              </Box>

              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Color Detection")}
                </Box>
              </Box>
            </Box>
            )}

            {/* <Box className={`livis-landing-header-routes-wrap ${route === "inspector" ? "active" : ""}`} tabIndex={0} onClick={() => handleNavigate("/app/inspector/list")} onKeyDown={(e) => handleTabNavigateWorkstation(e, "/app/inspector/list")}>
            {
              route === "inspector" ? (
                <InspectorActiveIcon />
              ) : (
                <InspectorIcon />
              )
            }
            <Box className="livis-landing-header-routes-text-wrap route-label">
              <div>{t("AI")}</div>
              <div>{t("Inspector")}</div>
            </Box>

            <Box className="livis-landing-header-route-hover-tooltip-container">
              <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
              <Box className="livis-landing-header-route-hover-tooltip-wrap">
                {t("AI Inspector")}
              </Box>
            </Box>
          </Box>

          */}
          </Box>
          
          {/* Mobile Profile Avatar beside logo */}
          <div 
            className="livis-landing-header-user-profile-wrap mobile-avatar-only"
            onClick={handleProfileMenu}
            style={{ cursor: "pointer" }}
          >
            <div className="livis-landing-header-user-avatar">
              <span className="livis-landing-header-user-initials">
                {userInfo?.email
                  ?.split("@")[0]
                  ?.substring(0, 2)
                  .toUpperCase() || "US"}
              </span>
              <span className="livis-landing-header-user-status-dot"></span>
            </div>
          </div>
        </Box>

        <Box className="livis-landing-header-right-container">
          <Box className="livis-landing-header-theme-language-container">
            <Box className="livis-landing-header-theme-select-container" />


            <Box className="livis-landing-header-language-select-container">
              <FormControl>
                <Select
                  value={selectedLanguage}
                  onChange={handleLanguageChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  input={
                    <OutlinedInput
                      startAdornment={
                        <InputAdornment position="start">
                          <img
                            className="livis-header-lang-img"
                            src={selectedIcon}
                            alt=""
                          />
                        </InputAdornment>
                      }
                    />
                  }
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span>{t("Select Language")}</span>
                    }
                    const selectedItem = languages.find(
                      (item) => item.label === selected
                    )
                    return (
                      <div className="livis-header-select-language-container">
                        {selectedItem?.label}
                      </div>
                    )
                  }}
                >
                  {languages?.map((item: any, index: any) => {
                    const lng_img = process.env.PUBLIC_URL + item?.icon
                    return (
                      <MenuItem
                        value={item?.label}
                        key={`lng-${index}`}
                        className="livis-header-select-language"
                      >
                        <img
                          src={lng_img}
                          alt={item?.language}
                          className="livis-header-lang-img"
                        />
                        {item?.language}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box className="livis-landing-header-settings-container">
            <div
              className="livis-landing-header-routes-wrap"
              tabIndex={0}
              onClick={handleThemeMenuOpen}
              style={{ cursor: "pointer" }}
            >
              {currentThemeMode === "light" ? (
                <Sun style={{ width: "18px", height: "18px", color: "var(--livis-color-primary-gray)" }} />
              ) : (
                <Moon style={{ width: "18px", height: "18px", color: "var(--livis-color-primary-gray)" }} />
              )}
              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Theme Settings")}
                </Box>
              </Box>
            </div>
            <div
              className={`livis-landing-header-routes-wrap ${
                route === "manage" ? "active" : ""
              }`}
              tabIndex={0}
              onClick={() =>
                doesUserHasAccess(151)
                  ? handleNavigate("/app/client/user/manage")
                  : handleNavigate("/app/user/MyProfile")
              }
              onKeyDown={(e) =>
                doesUserHasAccess(151)
                  ? handleTabNavigateWorkstation(e, "/app/client/user/manage")
                  : handleTabNavigateWorkstation(e, "/app/user/MyProfile")
              }
              onMouseOver={(e) => handleMouseInIcon(e, setting_icon_bold)}
              onMouseOut={(e) => handleMouseOutIcon(e, setting_icon)}
            >
              {route.includes("manage") ||
              route.includes("client") ||
              route == "tag-management" ||
              route == "logs" ||
              route == "subscription" ||
              route == "ongoing-training" ||
              route.includes("user") ? (
                <SettingsBoldIcon />
              ) : (
                <SettingsRegularIcon />
              )}
              <Box className="livis-landing-header-route-hover-tooltip-container">
                <Box className="livis-landing-header-route-hover-tooltip-ball"></Box>
                <Box className="livis-landing-header-route-hover-tooltip-wrap">
                  {t("Settings")}
                </Box>
              </Box>
            </div>

            {doesUserHasAccess(172) && (
              <div
                className={`livis-landing-header-routes-wrap ${
                  route === "manage" ? "active" : ""
                } livis-landing-header-alert-icon`}
                tabIndex={0}
                onClick={handleNotificationMenu}
                onKeyDown={(e) =>
                  handleTabNavigateWorkstation(e, "/app/client/user/manage")
                }
                onMouseOver={(e) => handleMouseInIcon(e, alert_icon_bold)}
                onMouseOut={(e) => handleMouseOutIcon(e, alert_icon)}
                style={{ position: "relative" }}
              >
                <AlertRegularIcon />

                {unreadCount > 0 && (
                  <span className="livis-notification-badge-dot"></span>
                )}
              </div>
            )}

            {/* User Profile Avatar with Dropdown Menu */}
            <div 
              className="livis-landing-header-user-profile-wrap"
              onClick={handleProfileMenu}
              style={{ cursor: "pointer" }}
            >
              <div className="livis-landing-header-user-avatar">
                <span className="livis-landing-header-user-initials">
                  {userInfo?.email
                    ?.split("@")[0]
                    ?.substring(0, 2)
                    .toUpperCase() || "US"}
                </span>
                <span className="livis-landing-header-user-status-dot"></span>
              </div>
            </div>
          </Box>
        </Box>

        <Menu
          anchorEl={profileEl}
          open={openProfileMenu}
          onClose={() => setProfileEl(null)}
          onClick={() => setProfileEl(null)}
          PaperProps={{
            elevation: 3,
            className: "livis-menu-header-profile-paper"
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          className="livis-menu-header-profile-section"
        >
          <Box className="livis-profile-menu-info">
            <div className="livis-profile-menu-name">
              {userInfo?.first_name 
                ? `${userInfo.first_name} ${userInfo.last_name || ""}`.trim()
                : (formatString(userInfo?.email?.split("@")?.[0]) || t("User"))}
            </div>
            <div className="livis-profile-menu-email">
              {userInfo?.email || ""}
            </div>
          </Box>
          <Divider className="livis-profile-menu-divider" />
          <MenuItem 
            onClick={() => {
              setProfileEl(null);
              handleNavigate("/app/user/MyProfile");
            }}
            className="livis-profile-menu-item"
          >
            <User size={16} />
            {t("My Profile")}
          </MenuItem>
          <Divider className="livis-profile-menu-divider" />
          <MenuItem 
            onClick={() => {
              setProfileEl(null);
              handleLogoutModal();
            }}
            className="livis-profile-menu-item-logout"
          >
            <PowerRegularIcon />
            {t("Logout")}
          </MenuItem>
        </Menu>

        <LivisNotificationMenu
          anchorEl={notificationEl}
          open={openNotificationMenu}
          onClose={() => setNotificationEl(null)}
          onViewAllClick={handleViewAllNotifications}
        />

        {/* Integrated Theme switcher dropdown Menu */}
        <Menu
          anchorEl={themeEl}
          open={openThemeMenu}
          onClose={handleThemeMenuClose}
          PaperProps={{
            elevation: 3,
            className: "livis-theme-popover-paper"
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box
            className="livis-theme-popover-box"
            sx={{ paddingTop: "0.5rem !important" }}
          >
            <div
              className="livis-theme-popover-brand-header"
              style={{
                lineHeight: 1.5,
                paddingTop: "2px",
                paddingBottom: "6px",
                overflow: "visible",
                display: "block",
              }}
            >
              {t("Theme Mode")}
            </div>
            
            <ToggleButtonGroup
              value={currentThemeMode}
              exclusive
              onChange={handleThemeChange}
              aria-label="theme mode"
              className="livis-theme-popover-toggle-group"
              size="small"
            >
              <ToggleButton 
                value="light" 
                className={`livis-theme-popover-toggle-btn ${currentThemeMode === 'light' ? 'active' : ''}`}
              >
                <Sun size={16} />
                {t("Light")}
              </ToggleButton>
              <ToggleButton 
                value="dark" 
                className={`livis-theme-popover-toggle-btn ${currentThemeMode === 'dark' ? 'active' : ''}`}
              >
                <Moon size={16} />
                {t("Dark")}
              </ToggleButton>
            </ToggleButtonGroup>

            <Divider />

            <div
              className="livis-theme-popover-brand-header"
              style={{
                lineHeight: 1.5,
                paddingTop: "2px",
                paddingBottom: "6px",
                overflow: "visible",
                display: "block",
              }}
            >
              {t("Brand Color")}
            </div>

            <Grid container spacing={1.5}>
              {brandColors.map((color: any) => {
                const isSelected = currentBrandColor === color.value;
                return (
                  <Grid item xs={3} key={color.name} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      onClick={() => handleColorChange(color.value)}
                      className={`livis-theme-popover-brand-btn ${isSelected ? 'selected' : ''}`}
                      style={{
                        backgroundColor: color.value,
                        boxShadow: isSelected ? `0 0 0 2px ${color.value}` : 'none',
                      }}
                      title={String(t(color.name))}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Menu>

        {/* Hamburger Floating Sidebar (Drawer) */}
        <Drawer
          anchor="left"
          open={openHamburger}
          onClose={() => setHamburgerEl(null)}
          PaperProps={{
            sx: {
              width: "280px",
              padding: "1.5rem 1rem",
              backgroundColor: "var(--livis-white-color)",
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              boxShadow: "4px 0px 20px rgba(0,0,0,0.08)",
              borderRight: "1px solid var(--livis-border-color)"
            }
          }}
        >
          <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <img src={livisLogo} alt="Logo" style={{ maxHeight: "32px" }} />
            </Box>
            <IconButton onClick={() => setHamburgerEl(null)}>
              <CloseIcon style={{ color: "var(--livis-color-primary-gray)" }} />
            </IconButton>
          </Box>

          <Divider />

          <List style={{ display: "flex", flexDirection: "column", gap: "0.5rem", padding: 0 }}>
            {[
              {
                label: t("Home"),
                route: "inspection",
                path: "/app/inspection/station",
                icon: route !== "reports" && route !== "deployment" && route !== "builder" && route !== "class-library" && route !== "color-detection" ? <StationActiveIcon /> : <StationIcon />
              },
              {
                label: t("Reports"),
                route: "reports",
                path: "/app/reports",
                icon: route === "reports" ? <ReportsActiveIcon /> : <ReportsIcon />
              },
              {
                label: t("Analytics"),
                route: "reports-analytics",
                path: "/app/reports-analytics",
                icon: route === "reports-analytics" ? <DashboardActiveIcon /> : <DashboardIcon />
              },
              {
                label: t("Recipe"),
                route: "deployment",
                path: "/app/deployment/list",
                icon: route === "deployment" ? <RecipeActiveIcon /> : <RecipeIcon />
              },
              {
                label: t("Layouts"),
                route: "builder",
                path: "/app/builder/layouts",
                icon: route === "builder" ? <LayoutActiveIcon /> : <LayoutIcon />
              },
              ...(doesUserHasAccess(175) ? [{
                label: t("Class Library"),
                route: "class-library",
                path: "/app/class-library",
                icon: route === "class-library" ? <StationActiveIcon /> : <StationIcon />
              }] : []),
              ...(doesUserHasAccess(181) ? [{
                label: t("Color Detection"),
                route: "color-detection",
                path: "/app/color-detection",
                icon: <PaintBucket style={{ width: "24px", height: "24px", color: route === "color-detection" ? "#ffffff" : "#667085" }} />
              }] : [])
            ].map((item) => {
              const isActive = route === item.route || (item.route === "inspection" && route !== "reports" && route !== "deployment" && route !== "builder" && route !== "class-library" && route !== "color-detection");
              return (
                <ListItem
                  key={item.label}
                  onClick={() => {
                    handleNavigate(item.path);
                    setHamburgerEl(null);
                  }}
                  style={{
                    borderRadius: "8px",
                    cursor: "pointer",
                    padding: "0.75rem 1rem",
                    backgroundColor: isActive ? "var(--livis-color-primary-blue)" : "transparent",
                    color: isActive ? "#ffffff !important" : "var(--livis-color-primary-gray) !important",
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    margin: 0
                  }}
                  className={isActive ? "active" : ""}
                >
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "24px", height: "24px" }}>
                    {item.icon}
                  </div>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: isActive ? "Noto Sans SemiBold !important" : "Noto Sans Regular",
                        fontSize: "14px",
                        fontWeight: isActive ? 600 : 500,
                        color: isActive ? "var(--livis-color-primary-blue) !important" : "var(--livis-color-primary-gray) !important"
                      }
                    }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Drawer>

        {/* logout modal */}
        <LivisModal
          size="small"
          animation_type="slideup"
          modal_open={logoutModal}
          title={t("Logout")}
          livis_dismiss_btn={() => setLogoutModal(false)}
          disable_outside_click={true}
          cancel_icon={true}
          livis_modal_class="livis-confirm-close-modal"
        >
          <>
            <p>{t("Do you want to logout?")}</p>
            <Grid container className="livis-landing-heading-logout-modal-grid">
              <Button
                variant="outlined"
                size="medium"
                className="livis-modal-btn-round livis-modal-cancel-close-btn"
                onClick={() => setLogoutModal(false)}
              >
                {t("Cancel")}
              </Button>
              <Button
                variant="contained"
                size="medium"
                className="livis-modal-btn-round livis-modal-cancel-danger-btn"
                onClick={() => handleLogout()}
              >
                {t("Yes, Logout")}
              </Button>
            </Grid>
          </>
        </LivisModal>

        {/* Blocking plan-lock modal — shown whenever the plan is expired or
            not found. Cannot be dismissed; the only way out is Logout. */}
        <LivisModal
          size="small"
          animation_type="zoom"
          modal_open={planExpired}
          title=""
          livis_dismiss_btn={() => { return null }}
          disable_outside_click={true}
          cancel_icon={false}
          livis_modal_class="livis-plan-lock-modal"
        >
          <div className="livis-plan-lock-modal-body">
            <div className="livis-plan-lock-modal-icon-wrap">
              <LockKeyhole size={26} strokeWidth={2.25} />
            </div>
            <span className="livis-plan-lock-modal-badge">
              <ShieldAlert size={13} strokeWidth={2.25} />
              {t("Access Restricted")}
            </span>
            <h2 className="livis-plan-lock-modal-title">{planLockMessage}</h2>
            <p className="livis-plan-lock-modal-subtext">
              {t("Please contact your administrator to continue using LIVIS.")}
            </p>
            <Button
              variant="contained"
              size="medium"
              className="livis-plan-lock-modal-logout-btn"
              onClick={() => handleLogout()}
              startIcon={<LogOut size={17} />}
            >
              {t("Logout")}
            </Button>
            <p className="livis-plan-lock-modal-footnote">
              {t("You'll be signed out of this session.")}
            </p>
          </div>
        </LivisModal>
      </Box>
      {/* TRIAL ALERT BANNER PLACED BELOW HEADER BOX */}
      <TrialAlertBanner />
    </>
  )
}
export default LandingHeader